import React from 'react';

class BackgroundGradient extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      background_type: props.background_type,
      gradient_from: props.gradient_from,
      gradient_to: props.gradient_to,
    };
  }

  shouldComponentUpdate(nextProps) {
    const bg = document.querySelector('#hu-background .hu-background-gradient');
    if (nextProps.background_type !== 'gradient')
      bg.className = bg.className.replace(/\sselected/g, '');
    else 
      bg.className = 'hu-background-gradient' + ' selected';
    return false;
  }

  render() {
    const { background_type, gradient_from, gradient_to } = this.props;
    const selected = background_type === 'gradient';

    return (
      <div className={ selected ? 'hu-background-gradient selected' : 'hu-background-gradient' }></div>
    )
  }
}

export default BackgroundGradient;


// WEBPACK FOOTER //
// ./app/js/components/background/BackgroundGradient.js